<template>
    <TermsCheck
        :content="listText"
        :is-loading="isLoading"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsA5, postAgreeA5 } from '@/apis/A5';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';
export default {
    components: {
        TermsCheck
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);

        /** 取得條款內容 */
        getAgreeTermsA5().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeA5().then(() => {
                router.push({
                    name: routeName.ONE_TIME_INVEST
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
